(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shled-collection-header"] && !Shopify.designMode) return;
  try {
    
const shledFacetPanelSelector = '.facets__panel';
const shledFacetPrefix = 'filter-p-m-shled-';

function shledFacetOrder() {
  const shell = document.querySelector('.shled-collection-shell[data-shled-filter-order]');
  if (!shell) return [];
  return (shell.dataset.shledFilterOrder || '').split(',').map((item) => item.trim()).filter(Boolean);
}

function shledFacetKey(panel, order) {
  return order.find((key) => panel.id.includes(`${shledFacetPrefix}${key}`));
}

function applyShledFacetProfile() {
  const order = shledFacetOrder();
  if (!order.length) return;

  const panels = Array.from(document.querySelectorAll(shledFacetPanelSelector));
  if (!panels.length) return;

  const matchedPanels = panels.filter((panel) => shledFacetKey(panel, order));
  if (!matchedPanels.length) return;

  panels.forEach((panel) => {
    const key = shledFacetKey(panel, order);
    if (key) {
      panel.style.removeProperty('display');
      panel.dataset.shledFacetKey = key;
    } else {
      panel.style.display = 'none';
      delete panel.dataset.shledFacetKey;
    }
  });

  const parents = new Set(matchedPanels.map((panel) => panel.parentElement).filter(Boolean));
  parents.forEach((parent) => {
    const directPanels = Array.from(parent.children).filter((child) => child.matches?.(shledFacetPanelSelector));
    const desiredPanels = order.flatMap((key) => directPanels.filter((panel) => panel.dataset.shledFacetKey === key));
    const currentVisible = directPanels.filter((panel) => panel.style.display !== 'none');
    const sameOrder =
      desiredPanels.length === currentVisible.length &&
      desiredPanels.every((panel, index) => panel === currentVisible[index]);

    if (!sameOrder) desiredPanels.forEach((panel) => parent.appendChild(panel));
  });

  document.querySelectorAll('.facets__filters-wrapper').forEach((wrapper) => {
    const hasVisible = Array.from(wrapper.querySelectorAll(shledFacetPanelSelector)).some(
      (panel) => panel.style.display !== 'none'
    );
    wrapper.toggleAttribute('data-shled-empty', !hasVisible);
  });
}

let shledFacetFrame;
function scheduleShledFacetProfile() {
  cancelAnimationFrame(shledFacetFrame);
  shledFacetFrame = requestAnimationFrame(applyShledFacetProfile);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleShledFacetProfile, { once: true });
} else {
  scheduleShledFacetProfile();
}

const shledFacetObserver = new MutationObserver((records) => {
  const hasFacetChange = records.some((record) =>
    Array.from(record.addedNodes).some(
      (node) =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches?.(shledFacetPanelSelector) || node.querySelector?.(shledFacetPanelSelector))
    )
  );
  if (hasFacetChange) scheduleShledFacetProfile();
});

shledFacetObserver.observe(document.documentElement, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shled-model-directory"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-shled-model-directory]').forEach((directory) => {
  const cards = Array.from(directory.querySelectorAll('[data-model-card]'));
  const filters = Array.from(directory.querySelectorAll('[data-model-filter]'));
  const count = directory.querySelector('[data-shled-model-count]');
  const empty = directory.querySelector('[data-model-empty]');
  const compareBar = directory.querySelector('[data-compare-bar]');
  const compareCount = directory.querySelector('[data-compare-count]');
  const compareLabels = directory.querySelector('[data-compare-labels]');
  const compareOpen = directory.querySelector('[data-compare-open]');
  const compareClear = directory.querySelector('[data-compare-clear]');
  const compareDialog = directory.querySelector('[data-compare-dialog]');
  const compareClose = directory.querySelector('[data-compare-close]');
  const compareTable = directory.querySelector('[data-compare-table]');
  const splitValues = (card,key) => (card.dataset[key] || '').split('|').map((v) => v.trim()).filter(Boolean);

  ['series','length','voltage','power','control','output','ip','pitch'].forEach((key) => {
    const select = directory.querySelector('[data-model-filter="' + key + '"]');
    if (!select) return;
    const values = [...new Set(cards.flatMap((card) => splitValues(card,key)))];
    values.sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value.toLowerCase();
      option.textContent = key === 'length' ? value + ' mm' : key === 'voltage' ? value + 'V' : key === 'power' ? value + ' ' + directory.dataset.powerUnit : value;
      select.appendChild(option);
    });
  });

  function applyFilters() {
    const state = {};
    filters.forEach((filter) => { state[filter.dataset.modelFilter] = filter.value.trim().toLowerCase(); });
    let visible = 0;
    cards.forEach((card) => {
      const contains = (key,value) => !value || splitValues(card,key).some((item) => item.toLowerCase() === value);
      let configurations = [];
      try { configurations = JSON.parse(card.dataset.configurations || '[]'); } catch (error) { configurations = []; }
      const hasConfigFilter = state.length || state.voltage || state.power || state.control || state.output;
      const configMatches = !hasConfigFilter || configurations.some((configuration) => {
        const lengthMatches = !state.length || Number(configuration.length_mm) === Number(state.length);
        const voltageMatches = !state.voltage || Number(configuration.voltage_v) === Number(state.voltage);
        const powerMatches = !state.power || Number(configuration.power_w) === Number(state.power);
        const controlMatches = !state.control || String(configuration.control || '').toLowerCase() === state.control;
        const outputMatches = !state.output || String(configuration.output || '').toLowerCase() === state.output;
        return lengthMatches && voltageMatches && powerMatches && controlMatches && outputMatches;
      });
      const fallbackMatches = contains('length',state.length) && contains('voltage',state.voltage) && contains('power',state.power) && contains('control',state.control) && contains('output',state.output);
      const matches = (!state.search || (card.dataset.modelCode || '').includes(state.search)) && contains('series',state.series) && contains('ip',state.ip) && contains('pitch',state.pitch) && (configurations.length ? configMatches : fallbackMatches);
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    if (count) count.textContent = visible;
    if (empty) empty.hidden = visible !== 0;
  }

  const selectedCards = () => cards.filter((card) => card.querySelector('[data-compare-toggle]')?.checked);
  function updateCompare() {
    const selected = selectedCards();
    compareBar.hidden = selected.length === 0;
    compareCount.textContent = selected.length;
    compareOpen.disabled = selected.length < 2;
    compareLabels.innerHTML = selected.map((card) => '<span>' + card.dataset.modelLabel + '</span>').join('');
    cards.forEach((card) => {
      const input = card.querySelector('[data-compare-toggle]');
      if (input && !input.checked) input.disabled = selected.length >= 4;
    });
  }
  cards.forEach((card) => {
    card.querySelector('[data-compare-toggle]')?.addEventListener('change', updateCompare);
  });
  compareClear?.addEventListener('click', () => {
    cards.forEach((card) => { const input = card.querySelector('[data-compare-toggle]'); if (input) { input.checked = false; input.disabled = false; } });
    updateCompare();
  });
  compareOpen?.addEventListener('click', () => {
    const selected = selectedCards();
    if (selected.length < 2) return;
    const rows = [
      [directory.dataset.labelFamily,'family'],
      [directory.dataset.labelSeries,'series'],
      [directory.dataset.labelLength,'length'],
      [directory.dataset.labelVoltage,'voltage'],
      [directory.dataset.labelPower,'power'],
      [directory.dataset.labelControl,'control'],
      [directory.dataset.labelOutput,'output'],
      [directory.dataset.labelIp,'ip'],
      [directory.dataset.labelPitch,'pitch'],
      [directory.dataset.labelBeam,'beam'],
      [directory.dataset.labelDimensions,'dimensions']
    ];
    let html = '<table class="shled-compare-table"><thead><tr><th>' + directory.dataset.labelParameter + '</th>';
    selected.forEach((card) => { html += '<th><a href="' + card.dataset.modelUrl + '">' + card.dataset.modelLabel + '</a></th>'; });
    html += '</tr></thead><tbody>';
    rows.forEach(([label,key]) => {
      html += '<tr><th>' + label + '</th>';
      selected.forEach((card) => {
        let value = card.dataset[key] || '—';
        if (['length','voltage','power','control','output','pitch','beam'].includes(key)) value = value.split('|').filter(Boolean).join(' / ') || '—';
        if (key === 'length' && value !== '—') value += ' mm';
        if (key === 'voltage' && value !== '—') value += 'V';
        if (key === 'power' && value !== '—') value += ' ' + (card.dataset.powerUnit || 'W');
        html += '<td>' + value + '</td>';
      });
      html += '</tr>';
    });
    compareTable.innerHTML = html + '</tbody></table>';
    compareDialog.showModal();
  });
  compareClose?.addEventListener('click', () => compareDialog.close());
  compareDialog?.addEventListener('click', (event) => { if (event.target === compareDialog) compareDialog.close(); });

  filters.forEach((filter) => filter.addEventListener(filter.tagName === 'INPUT' ? 'input' : 'change', applyFilters));
  directory.querySelector('[data-model-reset]')?.addEventListener('click', () => { filters.forEach((filter) => { filter.value = ''; }); applyFilters(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shled-model-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-shled-finder]').forEach((finder) => {
  const cards = Array.from(finder.querySelectorAll('[data-finder-card]'));
  const filters = Array.from(finder.querySelectorAll('[data-finder-filter]'));
  const count = finder.querySelector('[data-finder-count]');
  const empty = finder.querySelector('[data-finder-empty]');
  const splitValues = (card,key) => (card.dataset[key] || '').split('|').map((v) => v.trim()).filter(Boolean);
  ['family','type','voltage','power','control','output','ip','pitch'].forEach((key) => {
    const select = finder.querySelector('[data-finder-filter="' + key + '"]');
    if (!select) return;
    const values = key === 'power'
      ? [...new Set(cards.flatMap((card) => splitValues(card,key).map((value) => value + '|' + (card.dataset.powerUnit || 'W'))))].filter(Boolean)
      : [...new Set(cards.flatMap((card) => splitValues(card,key)))].filter(Boolean);
    values.sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value.toLowerCase();
      if (key === 'power') {
        const parts = value.split('|');
        option.textContent = parts[0] + ' ' + (parts[1] || 'W');
      } else {
        option.textContent = key === 'voltage' ? value + 'V' : value;
      }
      select.appendChild(option);
    });
  });
  function apply() {
    const state = {};
    filters.forEach((filter) => { state[filter.dataset.finderFilter] = filter.value.trim().toLowerCase(); });
    let visible = 0;
    cards.forEach((card) => {
      const contains = (key,value) => !value || splitValues(card,key).some((item) => item.toLowerCase() === value);
      let configurations = [];
      try { configurations = JSON.parse(card.dataset.configurations || '[]'); } catch (error) { configurations = []; }
      const selectedPower = state.power ? state.power.split('|') : [];
      const selectedPowerValue = selectedPower[0] || '';
      const selectedPowerUnit = selectedPower[1] || '';
      const hasConfigFilter = state.voltage || selectedPowerValue || state.control || state.output;
      const configMatches = !hasConfigFilter || configurations.some((configuration) => {
        const configurationUnit = configuration.power_basis === 'W/m' ? 'w/m' : 'w';
        return (!state.voltage || Number(configuration.voltage_v) === Number(state.voltage)) &&
          (!selectedPowerValue || (Number(configuration.power_w) === Number(selectedPowerValue) && configurationUnit === selectedPowerUnit)) &&
          (!state.control || String(configuration.control || '').toLowerCase() === state.control) &&
          (!state.output || String(configuration.output || '').toLowerCase() === state.output);
      });
      const fallbackPower = !selectedPowerValue || (contains('power',selectedPowerValue) && (card.dataset.powerUnit || 'W').toLowerCase() === selectedPowerUnit);
      const fallback = contains('voltage',state.voltage) && fallbackPower && contains('control',state.control) && contains('output',state.output);
      const matches = (!state.search || (card.dataset.code || '').includes(state.search)) &&
        contains('family',state.family) && contains('type',state.type) && contains('ip',state.ip) && contains('pitch',state.pitch) &&
        (configurations.length ? configMatches : fallback);
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    count.textContent = visible;
    empty.hidden = visible !== 0;
  }
  filters.forEach((filter) => filter.addEventListener(filter.tagName === 'INPUT' ? 'input' : 'change', apply));
  finder.querySelector('[data-finder-reset]')?.addEventListener('click', () => { filters.forEach((filter) => { filter.value = ''; }); apply(); });
  apply();
});

  } catch(e) { console.error(e); }
})();
})();
